import { useParams } from 'react-router';
import axios from 'axios';
import { useEffect, useState } from 'react';
import Navigation from '../../components/Navigation';
import CaseSlider from '../../components/case/CaseSlider';
import Brands from '../../components/Brands';
import TeamSlider from '../../components/team/TeamSlider';
import Footer from '../../components/Footer';
import useApiUrl from '../../framework/hooks/useApiUrlHook';

export default function ServiceDetail() {
    const apiUrl = useApiUrl();
    const { category, name } = useParams();
    const [detail, setDetail] = useState([]);

    function getButtonState(dienst, i) {
        if (dienst.url === name) return 'active show';
        if (name === undefined && i === 0) return 'active show';
        return '';
    }

    const getDetail = () => {
        axios
            .post(`${apiUrl}/service/detail`, { category })
            .then((response) => {
                setDetail(response.data);
            })
            .catch((err) => {
                // window.location.replace('/medemerkers');
            });
    };

    useEffect(() => {
        if (apiUrl != null) getDetail();
    }, [apiUrl]);

    return (
        <>
            <Navigation />
            <div
                className="s-hero-area logo-light"
                style={{
                    backgroundImage: `url(${apiUrl}/img/extern/ratio/www.bandwerk.nl/dienst_categorie/orig/2006/1598/100/${detail.header_image}`,
                }}
            >
                <div className="container">
                    <div className="row">
                        <div className="col-xl-12">
                            <div className="s-hero-content">
                                <div
                                    className="read-more mb-100 mb-lg-50 mb-md-50 mb-xs-30"
                                    data-aos="fade-up"
                                    data-aos-duration={1000}
                                >
                                    <a href="/onze-diensten">Terug naar overzicht</a>
                                </div>
                                <h2 data-aos="fade-up" data-aos-duration={1000}>
                                    {detail.titel}
                                </h2>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="s-about-area pt-100 pb-100 pt-xs-60 pb-xs-60">
                <div className="container">
                    <div className="row align-items-center">
                        <div className="col-xl-6">
                            <div className="s-about-content" data-aos="fade-up" data-aos-duration={1000}>
                                <h2>Visueel, functioneel</h2>
                                <h3>
                                    Wij zorgen ervoor dat jouw klanten online en offline verbonden worden met jouw merk.
                                </h3>
                            </div>
                        </div>
                        <div className="col-xl-6 text-center mt-lg-50 mt-md-50 mt-xs-50">
                            <div className="s-about-box" data-aos="fade-up" data-aos-duration={1000}>
                                <span>
                                    Zintuigen prikkelen<span className="dot">.</span>
                                </span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="s-tab-section logo-light pt-100 pb-100 pt-xs-60 pb-xs-60">
                <div className="container">
                    <div className="row">
                        <div className="col-xl-5 col-lg-5" data-aos="fade-up" data-aos-duration={1000}>
                            <div className="s-tab-nav">
                                <div className="nav nav-tabs" id="nav-tab" role="tablist">
                                    {detail?.diensten?.map((dienst, i) => (
                                        <button
                                            key={dienst.url.replace(/\(/g, '').replace(/\)/g, '')}
                                            className={`nav-link ${getButtonState(dienst, i)}`}
                                            id="nav-home-tab"
                                            data-bs-toggle="tab"
                                            data-bs-target={`#${dienst.url.replace(/\(/g, '').replace(/\)/g, '')}`}
                                            type="button"
                                            role="tab"
                                            aria-controls={dienst.url.replace(/\(/g, '').replace(/\)/g, '')}
                                            aria-selected="false"
                                        >
                                            <i className="fa-regular fa-angle-right" />
                                            {dienst.titel}
                                        </button>
                                    ))}
                                </div>
                            </div>
                        </div>
                        <div className="col-xl-7 col-lg-7 d-flex flex-column justify-content-center mt-5 mt-lg-0">
                            <div className="tab-content" id="nav-tabContent">
                                {detail?.diensten?.map((dienst, i) => (
                                    <div
                                        className={`tab-pane fade ${getButtonState(dienst, i)}`}
                                        id={dienst.url.replace(/\(/g, '').replace(/\)/g, '')}
                                        role="tabpanel"
                                        aria-labelledby="nav-home-tab"
                                        tabIndex={0}
                                    >
                                        <div className="s-tab-content">
                                            <h2>{dienst.subtitel}</h2>
                                            <p>{dienst.inleiding}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <CaseSlider />
            <Footer />
        </>
    );
}
